  $(document).ready(function(){
    let productsOnPage = $('.products-wrapper')
    let nextUrl = productsOnPage.attr('data-next-url')
    let loadMoreBtn = $('.load-more-btn');
    let loadMoreSpinner = $('.load-more-spinner');
    $('.load-more-btn').click(function(e){
    e.preventDefault();
    loadMoreBtn.hide()
    loadMoreSpinner.show()
    $.ajax({
      url: nextUrl,
      type: "GET",
      dataType: "html",
      success: function(nextPage){
        loadMoreSpinner.hide();
        let newProducts = $(nextPage).find('.products-wrapper')
        productsOnPage.append(newProducts.html());
        let newUrl = newProducts.attr('data-next-url');
        nextUrl = newUrl
        if(newUrl){
          loadMoreBtn.show();
        }
      }
    })

    })
  })

$(document).ready(function(){
      $('.slider').slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        adaptiveHeight: true,
        arrows: true  		  
      });

    $('.toppick').slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      adaptiveHeight: true,
      arrows: true  		  
    });
    
      $('.prodWrap').slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        adaptiveHeight: true,
        arrows: true  		  
      });      

      $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.slider-nav'
        });

      $('.slider-nav').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        dots: true,
        centerMode: true,
        focusOnSelect: true
      });    

      $('#sliderMenu').slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        adaptiveHeight: true,
        initialSlide: 2, 
        arrows: true  		  
      });      
      
      $(".navMenu li").click(function(){
        var text = $(this).find('a').attr("data-id"); // get clicked li text
        if (text) {
          $(".collection-highlite .imgCont img").removeClass("active");
          $(".collection-highlite .imgCont div.prodDetals").removeClass("active");
          $('.collection-highlite .imgCont'+' #'+text).addClass('active');

          $(".collection-highlite .navMenu li").removeClass("active");
          $(this).addClass('active');		
        }
      });      

      $('ul.unstyled-list li[data-title="COLLECTIONS"]').find('ul.mega-menu__linklist').hide();

      $('ul.unstyled-list li[data-title="LIFESTYLE"]').find('ul.mega-menu__linklist').hide();

    /* Countdown Time */
    var expDate = $('#endDate').val();  
    var endDate = new Date(expDate);
    var now = new Date();
    var diffInSeconds = Math.floor((endDate - now) / 1000);

    if (diffInSeconds < 0) diffInSeconds = 0;    

    $('.exclusiveClock').FlipClock(diffInSeconds, {
      clockFace: 'DailyCounter',
      countdown: true,
    });      


    });


// jQuery(document).ready(function($) {

//   function updateStockMessage(variant) {
//     if (!variant) return;
    
//     if (variant.available) {
//       $('.product-stock-message').textContent('');
//       console.log('in');
//     } else {
//       $('.product-stock-message').textContent('out');
//       console.log('out');
//     }
//   }
//   document.addEventListener('variant:change', function(event) {
//     const variant = window.Shopify?.currentVariant || window.product?.variants?.find(v => v.id === parseInt(document.querySelector('[name="id"]').value));
//     updateStockMessage(variant);
//   });
// });    

// pre order
// document.addEventListener('DOMContentLoaded', function() {
//   const message = document.createElement('p');
//   message.className = 'product-stock-message';
//   message.style.color = 'red';
//   const form = document.querySelector('form[action="/cart/add"]');
//   form.parentNode.insertBefore(message, form);

//   function updateMessage() {
//     const variant = window.Shopify?.currentVariant || window.product?.variants?.find(v => v.id === parseInt(document.querySelector('[name="id"]').value));
//     if (variant) {
//       if (variant.available) {
//         message.textContent = '';
//       } else {
//         message.textContent = '⚠️ Out of stock — available for preorder.';
//       }
//     }
//   }

//   document.querySelectorAll('select[name="id"], input[name="id"]').forEach(el => {
//     el.addEventListener('change', updateMessage);
//   });

//   updateMessage();
// });
// end pre order

var acc = document.getElementsByClassName("accordion");

for (var i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    // Close all other panels
    for (var j = 0; j < acc.length; j++) {
      if (acc[j] !== this) {
        acc[j].classList.remove("active");
        var otherPanel = acc[j].nextElementSibling;
        otherPanel.style.maxHeight = null;
      }
    }

    // Toggle the clicked one
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

/* exclusive video */
function playVideo() {
  var video = document.getElementById("myVideo");
  var cover = document.querySelector(".video-cover");
  
  cover.style.display = "none";       // hide cover
  video.play();                       // play video
}	


  function openCustomPopup() {
    document.getElementById('custom-popup').style.display = 'block';
  }

  function closeCustomPopup() {
    document.getElementById('custom-popup').style.display = 'none';
  }

  // Auto open if URL contains #popup
  document.addEventListener('DOMContentLoaded', function () {
    if (window.location.hash === '#contact_form') {
      openCustomPopup();
      history.replaceState(null, null, ' ');
    }
  });

  // Close when clicking outside the popup
  window.onclick = function (e) {
    var popup = document.getElementById('custom-popup');
    if (e.target === popup) {
      popup.style.display = "none";
    }
  };

    window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
      window.location.reload();
    }
  });

// ✅ Open the last accordion by default
// var lastAcc = acc[acc.length - 1];
// lastAcc.classList.add("active");
// var lastPanel = lastAcc.nextElementSibling;
// lastPanel.style.maxHeight = lastPanel.scrollHeight + "px";